import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import eventSessionsKeys from 'actions/eventSessions/queryKeys';
import api from 'utils/api';
import { ASSET_READ, ASSET_WRITE, hasPrivilege } from 'utils/privileges';
import config from 'utils/config';
export var useFetchEventSession = function useFetchEventSession(_ref) {
  var eventId = _ref.eventId,
    sessionId = _ref.sessionId,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    queryOptions = _ref.queryOptions;
  return useQuery(_objectSpread(_objectSpread({
    queryKey: eventSessionsKeys.eventSessionDetail(eventId, sessionId),
    queryFn: function queryFn() {
      return api('get', "/api/assets/".concat(eventId, "/sessions/").concat(sessionId));
    }
  }, queryOptions), {}, {
    enabled: enabled && config.eventAssets && (hasPrivilege(ASSET_READ) || hasPrivilege(ASSET_WRITE))
  }));
};
export default useFetchEventSession;